import { cn } from "../lib/utils";

export interface ProgressBarProps {
	value: number;
	max: number;
	caption?: string;
	isBuffering?: boolean;
	textClassName?: string;
}

export function ProgressBar({
	value,
	max,
	caption,
	isBuffering,
	textClassName,
}: ProgressBarProps): React.ReactElement {
	const progress = Math.round((value / max) * 100) / 100;
	return (
		<div
			className={cn(
				"relative h-6 w-full overflow-hidden rounded-progress bg-loader-outer-background",
			)}
		>
			<div
				className="absolute h-full rounded-progress bg-loader-progress-background transition-all"
				style={{ width: `${progress * 100}%` }}
			/>
			{isBuffering ? (
				<div className="absolute h-full w-full animate-[buffering_0.5s_linear_infinite] bg-buffering-pattern bg-buffering-repeat" />
			) : null}
			<span
				className={cn(
					"relative flex h-full w-full items-center px-md text-sm invert",
					textClassName,
				)}
			>
				{caption}
			</span>
		</div>
	);
}
